import { render, staticRenderFns } from "./Flux.vue?vue&type=template&id=3f3d4acc&scoped=true&"
import script from "./Flux.vue?vue&type=script&lang=js&"
export * from "./Flux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3d4acc",
  null
  
)

export default component.exports